import { testIdConstants } from "@/types/test-id-constants/testIdConstants";
import { IndentValues } from "@/lib/utils/IndentValues";
import { SpacingValues } from "@/lib/utils/SpacingValues";
import { InternalOverviewQuery } from "@/gql/graphql";
import { css, Global } from "@emotion/react";
import { Column, Spacing } from "@stenajs-webui/core";
import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { NslhPageHeader } from "../NslhPageHeader";
import { OverviewFilterBar } from "./components/OverviewFilterBar";
import { useFetchInternalOverviewBookings } from "./hooks/UseFetchInternalOverviewBookings";
import { OverviewScreen } from "./OverviewScreen";
import { createNslhInternalOverviewStateSelectors } from "./redux/selectors";
type NslhFollowUpByFilter =
  InternalOverviewQuery["productPrice"]["noShowLateHandling"]["nslhFollowUp"]["byFilter"];

interface Props {}
export interface OverviewBooking extends NslhFollowUpByFilter {
  pathToOneMonthBookings: string;
}

export const OverviewScreenWrapper: React.FC<Props> = () => {
  const { fetchOverviewData, loading, error, setError } =
    useFetchInternalOverviewBookings();
  const overviewBookings = useSelector(
    createNslhInternalOverviewStateSelectors.getNslhOverviewdData
  );

  const accountCardData = useSelector(
    createNslhInternalOverviewStateSelectors.getNslhOverviewAccountCardData
  );

  return (
    <>
      <Global
        styles={css`
          body {
            display: table;
          }
        `}
      />
      <Helmet title="Overview - NSLH - FPP" />
      <NslhPageHeader
        data-testid={testIdConstants.nslhPageHeader}
        actionBar={
          <OverviewFilterBar
            fetchOverviewData={fetchOverviewData}
            error={error}
            loading={loading}
            setError={setError}
          />
        }
        headingText={"Follow up"}
      />
      <Column indent={IndentValues.TWENTYFOUR}>
        <OverviewScreen
          overviewBookings={overviewBookings}
          accountCardData={accountCardData}
          error={error}
        />
        <Spacing num={IndentValues.TWENTYFOUR} />
      </Column>
    </>
  );
};
